"use client"

import { ApolloLink, HttpLink } from "@apollo/client"
import {
  ApolloClient,
  ApolloNextAppProvider,
  InMemoryCache,
  SSRMultipartLink,
} from "@apollo/experimental-nextjs-app-support"
import generatedIntrospection from "./introspection-result.json"

const GRAPHQL_URL =
  process.env.GRAPHQL_URL || "https://test-app-cms.azurewebsites.net/graphql"

function makeClient() {
  const httpLink = new HttpLink({
    uri: GRAPHQL_URL,
  })

  return new ApolloClient({
    cache: new InMemoryCache({
      possibleTypes: generatedIntrospection.possibleTypes,
    }),
    link:
      typeof window === "undefined"
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: true,
            }),
            httpLink,
          ])
        : httpLink,
  })
}

export function ApolloWrapper({ children }) {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  )
}
